// extracted by mini-css-extract-plugin
export default {"root":"Button_root__-+5Ui","fullWidth":"Button_fullWidth__mmwWm","primary":"Button_primary__MrUil","secondary":"Button_secondary__74bGJ"};